import { useApp } from "@next-platform/client-common-core";
import { Image, Spacer } from "@nextui-org/react";
import React, { useEffect, useMemo } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { Col, SpicyButton, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";
import useDownloadMobileApplicationsConfig from "@/features/mobileApplications/useDownloadMobileApplicationsConfig";

const ANDROID_INSTALLATION_IMAGE = "/Assets/androidInstallation.gif";

const INSTALL_STEP = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
} as const;

const getAppInstallStepValues = (count: number) => ({ count });

export default function AndroidInstallation() {
  const { applicationName } = useApp();
  const { androidApplication } = useDownloadMobileApplicationsConfig();
  const applicationNameValues = useMemo(() => ({ applicationName }), [applicationName]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageStaticMetaTags pageId="androidInstallation" />

      <Col align="center" className="text-center px-2">
        <h1>
          <Trans i18nKey="appInstall:header" values={applicationNameValues} />
        </h1>
        <h2>
          <Trans i18nKey="appInstall:title" />
        </h2>

        <Col gap={1} align="center">
          <Col>
            <h3>
              <Trans i18nKey="appInstall:step" values={getAppInstallStepValues(INSTALL_STEP.ONE)} />
            </h3>
            <Text>
              <Trans i18nKey="appInstall:step1" />
            </Text>
          </Col>
          <Col>
            <h3>
              <Trans i18nKey="appInstall:step" values={getAppInstallStepValues(INSTALL_STEP.TWO)} />
            </h3>
            <Text>
              <Trans i18nKey="appInstall:step2" />
            </Text>
          </Col>
          {androidApplication ? (
            <SpicyButton as="a" href={androidApplication.download_url} color="primary_strong" data-testid="AndroidInstallation-DownloadButton">
              <Text b type="white">
                <Trans i18nKey="appInstall:downloadButton" />
              </Text>
            </SpicyButton>
          ) : null}
          <Col>
            <h3>
              <Trans i18nKey="appInstall:step" values={getAppInstallStepValues(INSTALL_STEP.THREE)} />
            </h3>
            <Text>
              <Trans i18nKey="appInstall:step3" />
            </Text>
          </Col>
          <Col>
            <h3>
              <Trans i18nKey="appInstall:step" values={getAppInstallStepValues(INSTALL_STEP.FOUR)} />
            </h3>
            <Text>
              <Trans i18nKey="appInstall:step4" />
            </Text>
          </Col>
          <Col>
            <h3>
              <Trans i18nKey="appInstall:step" values={getAppInstallStepValues(INSTALL_STEP.FIVE)} />
            </h3>
            <Text>
              <Trans i18nKey="appInstall:step5" />
            </Text>
          </Col>
          <Col>
            <h3>
              <Trans i18nKey="appInstall:step" values={getAppInstallStepValues(INSTALL_STEP.SIX)} />
            </h3>
            <Text>
              <Trans i18nKey="appInstall:step6" values={applicationNameValues} />
            </Text>
          </Col>
        </Col>
        <Spacer y={6} />
        <Image src={ANDROID_INSTALLATION_IMAGE} />
      </Col>
    </>
  );
}
